import { AircraftGroupScheduleState } from './reducers';

export const getAircraftGroupSchedule = ({ pages: { aircraftGroupSchedule } }) =>
  aircraftGroupSchedule as AircraftGroupScheduleState;
